import { type ReactNode } from "react";

import { SegmentedTabsDesktop } from "./SegmentedTabsDesktop";

export type SegmentedTab<T> = {
  id: T;
  label: ReactNode | string;
  count?: number;
  disabled?: boolean;
  columnLayout?: boolean;
  icon?: ReactNode;
  iconPosition?: "left" | "right";
  tooltipContent?: string;
};

export type SegmentedTabsSize = "lg" | "sm";

export type SegmentedTabsVariant = "default" | "simple" | "sliding";

export type SegmentedTabsProps<T> = {
  tabs: SegmentedTab<T>[];
  defaultTab?: string;
  fullWidth?: boolean;
  size?: SegmentedTabsSize;
  activeTab?: T | string;
  setActiveTab: (id: T) => void;
  defaultTabColor?: "disabled" | "secondary";
  className?: string;
  fluidHeight?: boolean;
  variant?: SegmentedTabsVariant;
  columnLayout?: boolean;
  noWrapText?: boolean;
  alwaysDesktop?: boolean;
  ariaLabel?: string;
};

export function SegmentedTabs<T extends number | string>(
  props: SegmentedTabsProps<T>,
) {
  const { tabs } = props;

  if (tabs.length === 1) return;

  return <SegmentedTabsDesktop {...props} fluidHeight />;
}
